<template>
	<div>
		<van-nav-bar title="申请代理" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />

		<van-form @submit="onSubmit" v-if="!show">
			<van-cell-group title="联系方式">
				<van-field v-model="wechat" label="微信号" placeholder="微信号" :rules="[{ required: true, message: '请填写微信号' }]" />
			</van-cell-group>
			<van-cell-group title="请在下方填写申请理由">
				<van-field v-model="content" name="content" rows="5" autosize type="textarea" placeholder="申请理由"
				 maxlength="50" show-word-limit :rules="[{ required: true, message: '请输入申请理由' }]" />
			</van-cell-group>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交审核
				</van-button>
			</div>
		</van-form>
		<van-empty description="描述文字" v-else />
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		NavBar,
		CellGroup
	} from 'vant';

	Vue.use(CellGroup);
	Vue.use(NavBar);
	export default {
		data() {
			return {
				content: '',
				wechat: '',
				show: false
			}
		},
		mounted() {
			this.$ApiUtil.Agent.index().then( (res) => {
				if(res.status == 1){
					this.$router.push('/agent-center')
				}else if(res.status == 0){
					this.show = true
				}
			} )
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			},
			onSubmit(e) {
				this.$ApiUtil.Agent.post({
					put: JSON.stringify(e)
				}).then((res) => {
					this.$dialog.alert({
						message: res.message
					}).then(() => {
						this.$router.go(0)
					})
				})
			}
		}
	}
</script>

<style>
</style>
